/* globals localStorage */

export default {
  
  hasNotVerifiedEmail: false,

  login (email, pass, httpInstance, cb) {
      cb = arguments[arguments.length - 1]
      this.hasNotVerifiedEmail = false
      if (localStorage.token) {
        if (cb) cb(true)
        this.onChange(true)
        return
      }

      pretendRequest(email, pass, httpInstance, (res) => {
        if (res.authenticated) {
          this.setToken (res.token)
          this.setHeaderAuthorization (httpInstance)
          if (cb) cb(true)
          this.onChange(true)
        } else {
          if (cb) cb(false)
          this.onChange(false)
          if(res.hasNotVerifiedEmail) {
            this.hasNotVerifiedEmail = true
          }
          
        }
      })
  },
  
  getToken () {
    return localStorage.token
  },

  setToken (theToken) {
    localStorage.token = theToken
  },    

  setHeaderAuthorization (theInstance) {
    theInstance.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken()
  },    

  logout (cb) {
    delete localStorage.token
    if (cb) cb()
    this.onChange(false)
  },
  
  loggedIn () {
    return !!localStorage.token
  },
  
  hasVerifiedEmail () {
    return ! this.hasNotVerifiedEmail
  },

  onChange () {}
  }
  
  function pretendRequest (email, pass, httpInstance, cb) {
    var bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', pass);
    bodyFormData.append('grant_type', 'password');
    bodyFormData.append('client_id', 4);
    bodyFormData.append('client_secret', 'B6yRpuLktGzkH7TwUpzqR4C5J2zS8YLGnCS84KrE');
    bodyFormData.append('scope', '*');
    httpInstance({
      method: "post",
      url: '/login',
      data: bodyFormData,
      headers: { "Content-Type": "application/x-www-form-urlencoded"},
    })
    .then(response =>{
      if (response.data.access_token) {
        cb({
          authenticated: true,
          token: response.data.access_token
        })
      } else {
        cb({ authenticated: false })
      }
    })
    .catch((error) => {
      if (error.response.status == 403) {
        cb({
          hasNotVerifiedEmail: true,
        })
      }
      cb({ authenticated: false })
      console.error(error);
    });
    
  }
  